const emoji_icon = [
  '😀',
  '😃',
  '😄',
  '😁',
  '😆',
  '😅',
  '🤣',
  '😂',
  '🙂',
  '🙃',
  '😉',
  '😊',
  '😇',
  '😍',
  '🤩',
  '😘',
  '😗',
  '😚',
  '😙',
  '😋',
  '😛',
  '😜',
  '🤪',
  '😝',
  '🤑',
  '🤗',
  '🤭',
  '🤫',
  '🤔',
  '🤐',
  '🤨',
  '😐',
  '😑',
  '😶',
  '😏',
  '😒',
  '🙄',
  '😬',
  '🤥',
  '😌',
  '😔',
  '😪',
  '🤤',
  '😴',
  '😷',
  '🤒',
  '🤕',
  '🤢',
  '🤮',
  '🤧',
  '😵',
  '🤯',
  '🤠',
  '😎',
  '🤓',
  '🧐',
  '😕',
  '😟',
  '🙁',
  '😮',
  '😯',
  '😲',
  '😳',
  '😦',
  '😧',
  '😨',
  '😰',
  '😥',
  '😢',
  '😭',
  '😱',
  '😖',
  '😣',
  '😞',
  '😓',
  '😩',
  '😫',
  '😤',
  '😡',
  '😠',
  '🤬',
  '😈',
  '👿',
  '💀',
  '💩',
  '🤡',
  '👹',
  '👺',
  '👻',
  '👽',
  '👾',
  '🤖',
  '😺',
  '😸',
  '😹',
  '😻',
  '😼',
  '😽',
  '🙀',
  '😿',
  '😾',
  '💋',
  '👋',
  '🤚',
  '🖐',
  '✋',
  '🖖',
  '👌',
  '🤞',
  '🤟',
  '🤘',
  '🤙',
  '👈',
  '👉',
  '👆',
  '🖕',
  '👇',
  '👍',
  '👎',
  '✊',
  '👊',
  '🤛',
  '🤜',
  '👏',
  '🙌',
  '👐',
  '🤲',
  '🤝',
  '🙏',
  '💅',
  '🤳',
  '💪',
  '👂',
  '👃',
  '🧠',
  '👀',
  '👁',
  '👅',
  '👄',
  '👶',
  '🧒',
  '👦',
  '👧',
  '🧑',
  '👱',
  '👨',
  '🧔',
  '👱‍',
  '👨‍',
  '👨‍',
  '👨‍',
  '👨‍',
  '👩',
  '👱‍',
  '👩‍',
  '👩‍',
  '👩‍',
  '👩‍',
  '🧓',
  '👴',
  '👵',
  '🙍',
  '🙍‍',
  '🙍‍',
  '🙎',
  '🙎‍',
  '🙎‍',
  '🙅',
  '🙅‍',
  '🙅‍',
  '🙆',
  '🙆‍',
  '🙆‍',
  '💁',
  '💁‍',
  '💁‍',
  '🙋',
  '🙋‍',
  '🙋‍',
  '🙇',
  '🙇‍',
  '🙇‍',
  '🤦',
  '🤦‍',
  '🤦‍',
  '🤷',
  '🤷‍',
  '🤷‍',
  '👨‍⚕️',
  '👩‍⚕️',
  '👨‍🎓',
  '👩‍🎓',
  '👨‍🏫',
  '👩‍🏫',
  '👨‍⚖️',
  '👩‍⚖️',
  '👨‍🌾',
  '👩‍🌾',
  '👨‍🍳',
  '👩‍🍳',
  '👨‍🔧',
  '👩‍🔧',
  '👨‍🏭',
  '👩‍🏭',
  '👨‍💼',
  '👩‍💼',
  '👨‍🔬',
  '👩‍🔬',
  '👨‍💻',
  '👩‍💻',
  '👨‍🎤',
  '👩‍🎤',
  '👨‍🎨',
  '👩‍🎨',
  '👨‍✈️',
  '👩‍✈️',
  '👨‍🚀',
  '👩‍🚀',
  '👨‍🚒',
  '👩‍🚒',
  '👮',
  '👮‍♂️',
  '👮‍♀️',
  '🕵',
  '🕵️‍♂️',
  '🕵️‍♀️',
  '💂',
  '💂‍',
  '💂‍',
  '👷',
  '👷‍',
  '👷‍',
  '🤴',
  '👸',
  '👳',
  '👳‍',
  '👳‍',
  '👲',
  '🧕',
  '🤵',
  '👰',
  '🤰',
  '🤱',
  '👼',
  '🎅',
  '🤶',
  '🧙',
  '🧙‍',
  '🧙‍',
  '🧚',
  '🧚‍',
  '🧚‍',
  '🧛',
  '🧛‍',
  '🧛‍',
  '🧜',
  '🧜‍',
  '🧜‍',
  '🧝',
  '🧝‍',
  '🧝‍',
  '🧞',
  '🧞‍',
  '🧞‍',
  '🧟',
  '🧟‍',
  '🧟‍',
  '💆',
  '💆‍',
  '💆‍',
  '💇',
  '💇‍',
  '💇‍',
  '🚶',
  '🚶‍',
  '🚶‍',
  '🏃',
  '🏃‍',
  '🏃‍',
  '💃',
  '🕺',
  '🕴',
  '👯',
  '👯‍',
  '👯‍',
  '🧖',
  '🧖‍',
  '🧖‍',
  '🧘',
  '👭',
  '👫',
  '👬',
  '💏',
  '👨‍',
  '👩‍',
  '💑',
  '👨‍',
  '👩‍',
  '👪',
  '👨‍👩‍👦',
  '👨‍👩‍👧',
  '👨‍👩‍👧‍👦',
  '👨‍👩‍👦‍👦',
  '👨‍👩‍👧‍👧',
  '👨‍👨‍👦',
  '👨‍👨‍👧',
  '👨‍👨‍👧‍👦',
  '👨‍👨‍👦‍👦',
  '👨‍👨‍👧‍👧',
  '👩‍👩‍👦',
  '👩‍👩‍👧',
  '👩‍👩‍👧‍👦',
  '👩‍👩‍👦‍👦',
  '👩‍👩‍👧‍👧',
  '👨‍👦',
  '👨‍👦‍👦',
  '👨‍👧',
  '👨‍👧‍👦',
  '👨‍👧‍👧',
  '👩‍👦',
  '👩‍👦‍👦',
  '👩‍👧',
  '👩‍👧‍👦',
  '👩‍👧‍👧',
  '🗣',
  '👤',
  '👥',
  '👣',
  '🌂',
  '☂',
  '👓',
  '🕶',
  '👔',
  '👕',
  '👖',
  '🧣',
  '🧤',
  '🧥',
  '🧦',
  '👗',
  '👘',
  '👙',
  '👚',
  '👛',
  '👜',
  '👝',
  '🎒',
  '👞',
  '👟',
  '👠',
  '👡',
  '👢',
  '👑',
  '👒',
  '🎩',
  '🎓',
  '🧢',
  '⛑',
  '💄',
  '💍',
  '💼'
]
export default {
  emoji_icon
}
